import { render, staticRenderFns } from "./MyTrainings.vue?vue&type=template&id=7af7c22a&"
import script from "./MyTrainings.vue?vue&type=script&lang=js&"
export * from "./MyTrainings.vue?vue&type=script&lang=js&"
import style0 from "./MyTrainings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports